import React, { useEffect } from 'react'
import Options from './stages/Options'
import { useRaportForm } from '../../context/RaportFormContext'

const ShortRaportForm = ({
  vehicleActivity = false,
  separateFilesOnly = false,
}: {
  vehicleActivity?: boolean
  separateFilesOnly?: boolean
}) => {
  const { data, setData } = useRaportForm()
  useEffect(() => {
    setData((prev: any) => ({
      // onlyForActiveVehicles: false,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
      ...prev,
    }))
  }, [])
  return (
    <div className="tw-flex-1 tw-overflow-auto tw-p-4 tw-pr-8">
      <Options
        setData={setData}
        data={data}
        vehicleActivity={vehicleActivity}
        separateFilesOnly={separateFilesOnly}
      />
    </div>
  )
}

export default ShortRaportForm
